import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Product from '../views/product.vue'
import Contact from '../views/contact.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  }
]

const router = new VueRouter({
  routes
})

export default router
